console.log("process:", process.env)
const conf = {
    apibase: process.env.REACT_APP_APIBASE,//set in package proxy
    oidcConfig: {
        onSignIn: async (user: any) => {
            console.log('auth', user);
            setTimeout(() => {
                window.location.href = "/"
            }, 500);
        },
        authority: process.env.REACT_APP_AUTHORITY,
        clientId: 'CreditCheckExternal-UI',
        responseType: 'code',
        scope: 'openid profile jp_api.is4 role email',
        redirectUri: process.env.REACT_APP_REDIRECTURI
    }
}
export default conf